module.exports = __webpack_public_path__ + "static/media/saaya-logo-new.f83b08b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/saaya-logo-new.png
// module id = 63
// module chunks = 1